import styled from 'styled-components';
import {transparentize} from 'polished';
import BoxContainer from 'containers/BoxContainer';

export const Wrapper = styled(BoxContainer)`
  box-sizing: border-box;
  padding: 20px 14px;
  text-align: center;
  width: 200px;
  
  align-items: center;
  justify-content: center;
  display: inline-grid;
`;

export const Avatar = styled.img`
  margin: 0 auto 14px auto;
  border-radius: 50%;
  object-fit: cover;
  height: 100px;
  width: 100px;
`;

export const Name = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
`;

export const Role = styled.span`
  display: block;
  margin-top: 4px;
  line-height: 18px;
  font-size: 14px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
`;

export const Button = styled.div`
  margin-top: 14px;
`;
